export interface DataLayerEvent {
  readonly [key: string]: unknown;
}

declare global {
  interface Window {
    dataLayer?: DataLayerEvent[];
  }
}

const GTM_SCRIPT_ID = 'google-tag-manager';

const getGoogleTagManagerId = (): string => {
  return import.meta.env.VITE_GTM_ID?.trim() ?? '';
};

export const isGoogleTagManagerEnabled = (): boolean => {
  return getGoogleTagManagerId().length > 0;
};

export const initializeGoogleTagManager = (): void => {
  const gtmId = getGoogleTagManagerId();
  if (!gtmId || typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer ?? [];

  if (document.getElementById(GTM_SCRIPT_ID)) {
    return;
  }

  window.dataLayer.push({
    'gtm.start': Date.now(),
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.id = GTM_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;

  const firstScript = document.getElementsByTagName('script')[0];

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
    return;
  }

  document.head.appendChild(script);
};

export const pushToDataLayer = (event: DataLayerEvent): void => {
  if (!isGoogleTagManagerEnabled() || typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push(event);
};
